const value = {
    CHANGE_STATUS: 'Уведомление о переводе всех существующих “Статусов” для требований в одно из существующих значений',
    UPSERT_PROJECT: 'Создание нового изменение текущего проекта',
    CREATE_APPLICATION: 'Cоздание новой Анкеты АС в Проекте',
    EDIT_APPLICATION: 'Изменение существующей Анкеты АС в Проекте',
    CREATE_COMMENT_JIRA: 'Создание нового комментария к требованию в Jira',
    CREATE_REQUIREMENT: 'Создание нового требования в АС',
    INCLUDE_EXCLUDE_REQUIREMENT: 'Принятие/исключение требований в уже заполненных анкетах (красные/ синие маркеры)',
    CREATE_TEMPLATE: 'Создание нового Шаблона требований',
    EDIT_REQUIREMENT: 'Уведомление об изменении требования',
    CREATE_ADMIN: 'Уведомление добавлении нового администратора (в т.ч. локального администратора)',
    EDIT_ROLES_GROUP: 'Уведомление об изменении состава групп (изменение в ролевой модели, добавление пользователей)',
    EDIT_PASSWORD: 'Уведомление об изменении пароля локальных УЗ',
    UPSERT_ADDITIONAL_COLUMN: 'Уведомление об изменении/ добавлении доп.колонок.',
    CREATE_SYSTEM_ROLE: 'Уведомление о создании новой системной или проектной роли',
    EDIT_ADDITIONAL_COLUMN_CONTENT: 'Изменение содержимого доп колонки',
    TRANSFER_APPLICATION: 'Перенос Анкеты АС в другой Проект',
    COPY_APPLICATION: 'Копирование Анкеты АС в другой Проект',
    EDIT_REQUIREMENT_TEMPLATE: 'Обновление Шаблона требования',
    DELETE_REQUIREMENT_TEMPLATE: 'Удаление Шаблона требованияе',
    REQUIREMENT_ACCEPT: 'Обновление набора требований АС после изменения шаблонов требований',
  };

export default value;
